import React from 'react'
import PropTypes from 'prop-types'
import Text from 'src/Components/shared/Text'

const propTypes = {
  className: PropTypes.string
}

const defaultProps = {
  element: 'h3',
  size: 'l'
}

const RefiOptionHeadline = props => <Text {...props} />

RefiOptionHeadline.propTypes = propTypes
RefiOptionHeadline.defaultProps = defaultProps

export default RefiOptionHeadline
